import { DataTableDesignTokens } from '@primeuix/themes/types/datatable';

export const Table: DataTableDesignTokens = {
  colorScheme: {
    light: {
      root: {
        borderColor: '{surface.300}',
      },
      headerCell: {
        background: '{surface.100}',
        padding: '1rem'
      },
      row: {
        background: '{surface.0}',
        hoverBackground: '{secondary.50}',
      },
    },
  },
};
